import { debounce } from 'lodash';
import React from 'react';
import { SortingRule } from '@components/table';
import { userSearchDebounce } from '@components/hooks/use-search';
import { useWrapRequest } from '@components/hooks/use-wrap-request';
import { useSearchReducer } from '@components/hooks/useSearchReducer';
import { Api } from '@core/api';

import { injectTSDI } from '@core/tsdi';

export function useStore(communityId: number) {
    const { challengeClient } = injectTSDI(Api);

    const [sorting, setSorting] = React.useState<
        SortingRule | SortingRule[] | undefined
    >(undefined);

    React.useEffect(() => {
        if (sorting) {
            return dispatch({ type: 'sort', sort: sorting });
        }
    }, [sorting]);

    const [searchParams, dispatch] = React.useReducer(useSearchReducer, {
        size: 30,
        page: 0
    });
    const { setSearchTerm } = userSearchDebounce(dispatch);

    const challenges = useWrapRequest(
        async (searchParams?: QueryParamsDto) => {
            const result =
                await challengeClient.support.challengeSupportControllerGetPage(
                    {
                        communityIds: [communityId],
                        ...searchParams
                    }
                );

            return { ...result.data, content: result.data.content || [] };
        },
        {
            defaultData: {
                content: [],
                number: 0,
                size: 0,
                totalPages: 0,
                totalElements: 0
            }
        }
    );

    const debouncedAPICall = React.useCallback(
        debounce((searchParams?: QueryParamsDto) => {
            challenges.request([
                {
                    ...searchParams,
                    sort: '-ruleConfig.dateTimeRange.from'
                }
            ]);
        }, 100),
        []
    );

    React.useEffect(() => {
        debouncedAPICall(searchParams);
    }, [searchParams, debouncedAPICall]);

    return {
        challenges,
        searchParams,
        sorting,
        setSorting,
        setSearchTerm,
        dispatch
    };
}
